import React, { Fragment } from "react";
import { useRecoilState } from "recoil";
import { Loading } from "@kido/ui";
import { appThemeSelector } from "../../store/selectors";
import { ReactComponent as Load } from "./screens.svg";
import Billing from "../Billing";

const LoadingCmp = ({ counter }) => {
  const [theme] = useRecoilState(appThemeSelector);

  return (
    <Fragment>
      <Loading theme={theme}>
        <span className="block text-center font-bold text-xl">
          Pago realizado
        </span>
        <span className="block text-center">
          Su informe se esta preparando, espere unos segundos
        </span>
        <div className="mb-8"></div>
        <Load />
        <div className="mb-8"></div>
        Generando página {counter} de 6<div className="mb-8"></div>
      </Loading>
      <Billing />
    </Fragment>
  );
};

export default LoadingCmp;
